import React from 'react';
import {Badge} from 'reactstrap';
import {SextantInfo} from './SextantInfo';
import {SextantPerio} from "./SextantPerio";

class Sextant extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedTooth: ""
        };

        if (!this.props.hasOwnProperty('position')) {
            return; // @TODO fix
        }


    }

    componentWillMount() {
    }

    componentDidMount() {

    }

    render() {
        let perioInfo = null;
        if (this.props.tooth >= 1 && this.props.tooth <= 32) {
            perioInfo = <SextantPerio tooth={this.props.tooth} position={this.props.position} data={this.props.toothPerio} weights={this.props.weights}/>;
        }

        return (
            <div>
                {perioInfo}
                <SextantInfo size="sm" position={this.props.position} brushScore={this.props.score * 100}/>
            </div>
        );
    }
}

export {
    Sextant
};
